"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FontSize;
(function (FontSize) {
    FontSize["Small"] = "ty-font-sm";
    FontSize["Medium"] = "ty-font-md";
    FontSize["Large"] = "ty-font-lg";
    FontSize["XLarge"] = "ty-font-xl";
    FontSize["HeaderSmall"] = "ty-font-header-sm";
    FontSize["HeaderMedium"] = "ty-font-header-md";
    FontSize["HeaderLarge"] = "ty-font-header-lg";
})(FontSize = exports.FontSize || (exports.FontSize = {}));
